import React, { useContext, useState } from "react";
import trans, { isRTL } from "../../utils";
import { popupcontext } from "../../context/Popupscontext";
import { toast } from "react-toastify";
import Close from "../Helpers/CloseBtn/Close";
import Button from "../Helpers/Button/Button";
import { Modal } from "react-bootstrap";
import { Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
	setConfigId,
	setOfflineMode,
	setOfflineModules,
} from "../../Redux/service/Users/UsersSlice";
import { getData } from "../../utils/IndexedDB";

function SwitchModal({ switchMode, setSwitchMode }) {
	const { setConfigurationId } = useContext(popupcontext);
	const dispatch = useDispatch();
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const currentConfigurationId = useSelector((state) => state.users.configId);
	return (
		<Modal
			show={switchMode}
			centered
			dir={!isRTL ? "ltr" : "rtl"}
			className="offline-switch-modal"
		>
			<Modal.Header style={{ paddingBlock: "8px !important" }}>
				<div className="flex-between flex-row-reverse w-100">
					<Close
						// eslint-disable-next-line react/style-prop-object
						style="close-32 close"
						close={() => setSwitchMode(false)}
						img="Close"
					/>
				</div>
			</Modal.Header>
			<Modal.Body>
				<div style={{ fontWeight: "600", fontSize: "16px", color: "#192839" }}>
					{currentConfigurationId && !offlineMode
						? trans("Activate Offline Mode?")
						: trans("Switch Online Mode?")}
				</div>
				<div style={{ fontWeight: "400", fontSize: "12px", color: "#768EA7" }}>
					{currentConfigurationId && !offlineMode
						? trans("You’re about to switch to Offline Mode")
						: trans("You’re about to switch to Online Mode")}
				</div>
			</Modal.Body>
			<Modal.Footer>
				<Button
					type={"default"}
					onClick={() => setSwitchMode(false)}
					text={trans("Cancel")}
				/>
				<Button
					type="primary"
					onClick={async () => {
						if (currentConfigurationId && !offlineMode) {
							try {
								dispatch(setOfflineMode(true)); // ← then switch mode
							} catch (error) {
								console.error("IndexedDB read error:", error);
							}
							// seviceWorkerRegistration.register();
						} else if (currentConfigurationId && offlineMode) {
							if (!navigator.onLine) {
								toast.info(trans("You must have an internet connection"), {
									autoClose: 800,
									rtl: localStorage.getItem("lang") === "ar",
								});
								return;
							}
							dispatch(setOfflineMode(false));
							setConfigurationId(null);
							dispatch(setConfigId(null));
							// seviceWorkerRegistration.unregister();
						} else {
							return;
						}
						setSwitchMode(false);
					}}
					text={
						currentConfigurationId && !offlineMode
							? trans("Activate")
							: trans("Switch")
					}
				/>
			</Modal.Footer>
		</Modal>
	);
}

export default function ModeToggle() {
	const currentConfigurationId = useSelector((state) => state.users.configId);

	const [switchMode, setSwitchMode] = useState(false);
	const offlineMode = useSelector((state) => state.users.offlineMode);
	const { setHighlight } = useContext(popupcontext);
	const handleSwitchChange = (value) => {
		if (!currentConfigurationId) {
			setHighlight(true);

			toast.info(trans("Please select a configuration"), {
				autoClose: 800,
				rtl: localStorage.getItem("lang") === "ar",
			});

			setTimeout(() => setHighlight(false), 2000);

			return;
		}

		setSwitchMode(true);
	};

	return (
		<div
			className={`mode-toggle ${offlineMode ? "mode-toggle-offline" : "mode-toggle-online"}`}
			style={{
				backgroundColor: offlineMode ? "#FFF7E6" : "#EAF4EC",
			}}
		>
			<div
				style={{ color: offlineMode ? "#FA8C16" : "#2e9245" }}
				className={!isRTL ? "me-3" : "ms-3"}
			>
				{offlineMode ? trans("offline") : trans("online")}
			</div>
			<Switch
				className="custom-switch"
				checked={offlineMode}
				onChange={handleSwitchChange}
			/>
			<SwitchModal switchMode={switchMode} setSwitchMode={setSwitchMode} />
		</div>
	);
}
